import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing(1)};
  justify-content: space-between;
  width: ${(p) => p.theme.spacing(73)};
  margin: auto;
`;
